import React from 'react';

// @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
const CmailStateContext = React.createContext();

export const CmailStateProvider = ({ state, children }: any) => (
  <CmailStateContext.Provider value={state}>
    {children}
  </CmailStateContext.Provider>
);

export const useCmailContext = () => {
  return React.useContext<any>(CmailStateContext);
};
